import { Component } from '@angular/core';

@Component({
  selector: 'app-onboardclients',
  templateUrl: './onboardclients.component.html',
  styleUrls: ['./onboardclients.component.scss']
})
export class OnboardclientsComponent {

}
